import React, { useEffect, useState } from 'react';
import image4 from "../assets/image4.webp";
import image5 from "../assets/image5.webp";
import image6 from "../assets/image6.webp";
import image7 from "../assets/image7.webp";
import { FaArrowRightLong,FaArrowLeftLong } from "react-icons/fa6";
import { useRef } from 'react';

export default function Page3() {

   const scrollContainerRef = useRef(null);
  const [isEnd, setIsEnd] = useState(false);

  useEffect(() => {
    if (scrollContainerRef.current) {
      const container = scrollContainerRef.current;
      setIsEnd(container.scrollWidth - container.clientWidth === container.scrollLeft);
    }
  }, [isEnd]);






  return (
    <div className='page3_main_div '>
      <div className='row'>
        <div className='col'>
          <div className='d-flex  justify-content-between align-items-center'>
            <div className='px-3 andro_meda'>
            <h1 className='fw-bold pb-5'>How You Can Use Andromeda-Sim</h1>
           <div className='andro_meda_underline_div'></div>
            </div>
            <div className='d-none d-lg-block'>
  
          </div>
          </div>

          <div>

        <div className="d-none d-lg-flex flex-column flex-md-row justify-content-center align-items-center w-100 position-relative">


              <div className='position-relative p-2'>
              <img src={image6} className="rounded-4 me-2 custom-scroll-image " alt="Flight schools" />
              <div className="image-name-overlay">Flight schools </div>
            </div>
            
            <div className='position-relative p-2'>
              <img src={image4} className="rounded-4 me-2 custom-scroll-image  " alt="Flight training centers" />
              <div className="image-name-overlay">Flight training centers </div>
            </div>

            <div className='position-relative p-2'>
              <img src={image5} className="rounded-4 me-2 custom-scroll-image " alt="Aviation academies" />
              <div className="image-name-overlay">Aviation academies </div>
            </div>

  
            

      
            
          </div>
          
          </div>


          <div className=" d-block d-lg-none d-flex flex-column flex-row  position-relative" >
            

               <div className='position-relative  mb-4 '>
              <img src={image6} className="rounded-4 me-2  img-fluid" alt="Andromeda Image 3" />
              <div className="image-name-overlay">Flight schools </div>
            </div>
            <div className='position-relative  mb-4'>
              <img src={image4} className="rounded-4 me-2  img-fluid " alt="Andromeda Image 1" />
              <div className="image-name-overlay">Flight training centers </div>
            </div>

            <div className='position-relative '>
              <img src={image5} className="rounded-4 me-2  img-fluid" alt="Andromeda Image 2" />
              <div className="image-name-overlay">Aviation academies </div>
            </div>

         

         
            
          </div>


        </div>
      </div>
    </div>
  );
}
